import { Swiper } from 'swiper';
import 'swiper/css';

export default function latestNews() {
    if (document.querySelector('.latest-news__posts')) {
        initSwiper();
    }
}

const initSwiper = () => {
    const swiper = new Swiper('.latest-news__posts', {
        slidesPerView: 1.2,
        spaceBetween: 20,
        breakpoints: {
            1024: {
                enabled: false,
                slidesPerView: 3,
                spaceBetween: 24,
            },
        },
    });
};
